import React from 'react';
import {Button, Grid, TextField, Typography} from '@material-ui/core';
import css from 'client/components/slideshow/SlideshowPage.pcss';

const PasswordForm: React.FC = () => (
	<form>
		<Grid
			container
			className={css.accessWrapper}
			alignItems="center"
			justify="center"
			alignContent="center"
			spacing={4}
		>
			<Grid item component={Typography} variant="h5">
				Доступ ограничен паролем
			</Grid>

			<Grid item container spacing={4} justify="center">
				<Grid item>
					<TextField
						name="password"
						placeholder="Введите пароль"
						label="Пароль"
						variant="outlined"
						size={'small'}
					/>
				</Grid>

				<Grid item>
					<Button variant="outlined" color="primary" size="large" type="submit">
						Открыть
					</Button>
				</Grid>
			</Grid>
		</Grid>
	</form>
);

export default PasswordForm;
